export const formatDuration = (seconds) => {
    if (seconds === null || seconds === undefined) {
        return null;
    }
    const totalSeconds = Math.max(0, Math.round(seconds));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    if (hours > 0) {
        return `${hours}h ${minutes}m`;
    }
    if (minutes > 0) {
        return `${minutes}m`;
    }
    return `${totalSeconds}s`;
};

export const formatPercent = (value, fractionDigits = 1) => {
    if (value === null || value === undefined) {
        return null;
    }
    const factor = 10 ** fractionDigits;
    return `${Math.round(value * 100 * factor) / factor}%`;
};

export const formatDecimal = (value, fractionDigits = 2) => {
    if (value === null || value === undefined) {
        return null;
    }
    const factor = 10 ** fractionDigits;
    return (Math.round(value * factor) / factor).toString();
};

export const formatBytes = (value) => {
    if (value === null || value === undefined) {
        return null;
    }
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    let size = Math.max(0, value);
    let unitIndex = 0;
    while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024;
        unitIndex += 1;
    }
    return `${(Math.round(size * 10) / 10).toString()} ${units[unitIndex]}`;
};

export const formatInteger = (value) => {
    if (value === null || value === undefined) {
        return null;
    }
    return new Intl.NumberFormat().format(Math.round(value));
};

export const formatMilliseconds = (value) => {
    if (value === null || value === undefined) {
        return null;
    }
    return `${Math.round(value)} ms`;
};
